<template>
    <section>
        <div class="card shadow-sm mb-4 border-0">
            <div class="card-header background-primary">
                <div class="row justify-content-end">
                    <div class="col">
                        <router-link v-bind:to="{ name: 'branch/view', params: {id: branch.id} }" class="h4 font-weight-medium text-white mb-0">
                            Cabang # {{ index + 1 }}
                        </router-link>
                         <span class="badge badge-info ml-1">{{ branch.isHidden ? 'PP' : '' }}</span>
                    </div>
                    <div class="col-auto" v-if="profile.isAdmin">
                        <router-link v-bind:to="{ name: 'branch/edit', params: {id: branch.id} }" class="btn btn-link h4 p-0 my-0 mr-2">
                            Edit
                        </router-link>
                        <button class="btn btn-link h4 p-0 m-0" v-on:click="$emit('confirm', branch)">
                            Delete
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body text-center">
                <div class="card-title text-muted">
                    Logo Cabang:
                </div>
                <router-link v-bind:to="{ name: 'branch/view', params: {id: branch.id} }">
                    <img v-bind:src="branch.imageUrl" class="img-fluid mb-3" />
                </router-link>
                <div class="text-muted">
                    Nama Cabang:
                </div>
                <div>
                    {{ branch.name }}
                </div>
                <div class="text-muted">
                    Alamat Cabang:
                </div>
                <div>
                    {{ branch.address }}
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    
    /**
     * @param {Object} branch
     * @param {Integer} branch.id
     * @param {String} branch.name
     * @param {String} branch.address
     * @param {String} branch.image
     * @param {String} branch.imageUrl
     * @param {Boolean} branch.isPrimary
     * 
     * @event confirm({Object})
     */
    export default {
        name: "BranchItem",
        props: ['branch', 'index'],
        computed: mapState([
            'profile'
        ])
    };
</script>


// WEBPACK FOOTER //
// src/components/branch/item/Branch.vue